import { setTerm } from './helpers';

export const setHasRamp = setTerm('has_ramp');
